export enum EAdyenComponentState {
  PAYMENT,
  ADDITIONAL_ACTION,
  ERROR,
  COMPLETE,
  ORDER_CREATE_IN_PROGRESS,
  ORDER_CREATE_FAIL,
}
